import { render } from "./ProducerSearch.vue?vue&type=template&id=d3ddce28&scoped=true&ts=true"
import script from "./ProducerSearch.vue?vue&type=script&lang=ts"
export * from "./ProducerSearch.vue?vue&type=script&lang=ts"

import "./ProducerSearch.vue?vue&type=style&index=0&id=d3ddce28&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3ddce28"]])

export default __exports__